import config from '@medflex/utils/config';
import makeApiRequest, { getCancelToken } from '../../../api/makeApiRequest';

const NAME = 'pamRequests';

const cancelTokensByChatId = {};

const pamRequests = {
  name: NAME,
  state: {},
  reducers: {
    onLoad: (state, { chatId, requests, subscription }) => ({
      ...state,
      [chatId]: {
        ...state[chatId],
        requests,
        subscription,
      },
    }),
    onRequestCreated: (state, payload) => {
      if (!state[payload.chatId]) {
        return {
          ...state,
          [payload.chatId]: {
            requests: [payload],
          },
        };
      }

      return {
        ...state,
        [payload.chatId]: {
          ...state[payload.chatId],
          requests: [...state[payload.chatId].requests, payload],
        },
      };
    },
    onRequestUpdated: (state, payload) => {
      if (!state[payload.chatId]) {
        return {
          ...state,
          [payload.chatId]: {
            requests: [payload],
          },
        };
      }
      const requestsToKeep = state[payload.chatId].requests.filter(
        request => request.id !== payload.id,
      );
      const newRequests = [...requestsToKeep, payload];

      return {
        ...state,
        [payload.chatId]: {
          ...state[payload.chatId],
          requests: newRequests,
        },
      };
    },
    onRequestDeleted: (state, payload) => {
      if (!state[payload.chatId]) return state;

      const newRequests =
        state[payload.chatId]?.requests.filter(el => el.id !== payload.requestId) || [];

      return {
        ...state,
        [payload.chatId]: {
          ...state[payload.chatId],
          requests: newRequests,
        },
      };
    },
  },
  effects: dispatch => ({
    load: async ({ chatIds }, { oidcSession }) => {
      for (const chatId of chatIds) {
        const cancelToken = getCancelToken();
        if (!cancelTokensByChatId[chatId]) {
          cancelTokensByChatId[chatId] = cancelToken;
        } else {
          cancelToken.cancel();
        }

        const requestConfig = {
          url: `${config.PAM_API_URL}/requests/${chatId}/chat`,
          cancelToken: cancelToken.token,
        };

        /** @type any */
        const [request] = makeApiRequest(requestConfig, oidcSession);
        const { data, error } = await request;
        if (error) {
          dispatch.errors.add({ realm: NAME, type: 'load', error });
        } else {
          dispatch.errors.remove({ realm: NAME, type: 'load' });
          dispatch[NAME].onLoad({
            chatId,
            ...data,
          });
        }
      }
    },
  }),
  messageListeners: {
    'pam:request_created': function pamRequestCreated({ payload }) {
      this.onRequestCreated(payload);
    },
    'pam:request_updated': function pamRequestUpdated({ payload }) {
      this.onRequestUpdated(payload);
    },
    'pam:request_deleted': function pamRequestUpdated({ payload }) {
      this.onRequestDeleted(payload);
    },
  },
};

export default pamRequests;
